import styled from 'styled-components';
import { Tab, Tabs } from '@equinor/opt-ui-core';
import { FlexBlock } from '../Layout';
export const StyledTabs = styled(Tabs) `
  min-height: 48px;

  @media only screen and (max-width: 760px) {
    & .opt-tabs__container {
      overflow-x: auto;
    }
  }
`;
export const StyledTab = styled(Tab) `
  display: flex;
  min-height: 48px;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
`;
export const TabBlock = styled(FlexBlock) `
  flex-direction: column;
  margin-top: 2px;
  flex: 0;

  .opt-tabs .opt-tabs__list .opt-tab {
    box-shadow: none;
  }
`;
